import { render, staticRenderFns } from "./ListarRelatoriosLogFaq.vue?vue&type=template&id=ca0cc0b0&scoped=true&"
import script from "./ListarRelatoriosLogFaq.vue?vue&type=script&lang=js&"
export * from "./ListarRelatoriosLogFaq.vue?vue&type=script&lang=js&"
import style0 from "./ListarRelatoriosLogFaq.vue?vue&type=style&index=0&id=ca0cc0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0cc0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VForm,VRow,VTextField})
